document.querySelectorAll('.featured_reviews_slider').forEach(function (container) {
  const section = container.closest('[data-section-type="testimonials"]');
  const wrapper = container.querySelector('.swiper-wrapper');
  const slides = Array.from(wrapper.children);
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (slides.length < 2) return;
  let animation, duration, step, frame, inView = false, dragging = false;
  container.classList.add('reviews-continuous');
  const style = document.createElement('style');
  style.textContent = `
    .reviews-continuous { overflow:hidden; touch-action:pan-y; cursor:grab; }
    .reviews-continuous.is-dragging { cursor:grabbing; user-select:none; }
    .reviews-continuous:focus-visible { outline:2px solid #21314d; outline-offset:4px; }
    .reviews-continuous .swiper-wrapper { display:flex; gap:var(--review-gap); }
    .reviews-continuous .swiper-slide { width:var(--review-width); flex:0 0 var(--review-width); margin:0; }
    .reviews-continuous .swiper-scrollbar { display:none; }
    .reviews-continuous.reviews-static { overflow-x:auto; touch-action:auto; cursor:auto; }
    .reviews-static .swiper-wrapper { transform:none; }
  `;
  section.appendChild(style);
  function sync() {
    if (inView) wrapper.querySelectorAll('img[data-src]').forEach(image => {
      if (!image.getAttribute('src')) image.src = image.dataset.src;
      image.loading = 'eager';
    });
    const paused = motion.matches || !inView || dragging || document.hidden ||
      (window.matchMedia('(hover: hover) and (pointer: fine)').matches && container.matches(':hover')) || container.contains(document.activeElement);
    if (animation) paused ? animation.pause() : animation.play();

  }
  function rebuild() {
    if (animation) animation.cancel();
    animation = null;
    wrapper.querySelectorAll('[data-review-copy]').forEach(slide => slide.remove());
    const width = container.clientWidth;
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    const gap = mobile ? 16 : 30;
    const cardWidth = mobile ? Math.min(440, Math.max(340, width - 28)) : Math.max(440, (Math.min(width, 1440) - 45) / 2.5);
    step = cardWidth + gap;
    container.style.setProperty('--review-gap', gap + 'px');
    container.style.setProperty('--review-width', cardWidth + 'px');
    container.classList.toggle('reviews-static', motion.matches);
    container.style.removeProperty('--review-height');
    // Measure at the final card width so every card/row contains the longest review.
    const height = Math.ceil(Math.max(mobile ? 280 : 300, ...slides.map(slide => slide.querySelector('.featured-review-info').scrollHeight)));
    container.style.setProperty('--review-height', height + 'px');
    let cycleSlides = slides;
    if (mobile && slides.length % 2 && !motion.matches) {
      // An even cycle keeps the upper/lower image sides identical at every repeat.
      const extra = slides.map(slide => {
        const copy = slide.cloneNode(true);
        copy.dataset.reviewCopy = '';
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        copy.querySelectorAll('a,button,[tabindex]').forEach(element => element.setAttribute('tabindex', '-1'));
        wrapper.appendChild(copy);
        return copy;
      });
      cycleSlides = slides.concat(extra);
    }
    if (!motion.matches && width) {
      const distance = step * cycleSlides.length / (mobile ? 2 : 1);
      // Fill even ultra-wide viewports throughout an entire repeat.
      const copies = Math.ceil(width / distance);
      for (let group = 0; group < copies; group++) cycleSlides.forEach(slide => {
        const copy = slide.cloneNode(true);
        copy.dataset.reviewCopy = '';
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        copy.querySelectorAll('a,button,[tabindex]').forEach(element => element.setAttribute('tabindex', '-1'));
        wrapper.appendChild(copy);
      });
      duration = distance / 20 * 1000;
      animation = wrapper.animate(
        [{transform:'translateX(0)'}, {transform:'translateX(-' + distance + 'px)'}],
        {duration:duration, iterations:Infinity, easing:'linear'}
      );
    }
    sync();
  }
  function advance(direction) {
    if (!animation) { container.scrollBy({left:direction * step, behavior:motion.matches ? 'auto' : 'smooth'}); return; }
    animation.currentTime = ((animation.currentTime || 0) + direction * step / 20 * 1000 + duration) % duration;
  }
  container.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    advance(event.key === 'ArrowRight' ? 1 : -1);
  });
  container.addEventListener('mouseenter', sync);
  container.addEventListener('mouseleave', sync);
  container.addEventListener('focusin', sync);
  container.addEventListener('focusout', () => requestAnimationFrame(sync));
  let pointerX = 0, pointerY = 0, dragTime = 0;
  container.addEventListener('dragstart', event => event.preventDefault());
  container.addEventListener('pointerdown', event => {
    if (!animation || !event.isPrimary || event.button !== 0 || event.target.closest('a,button')) return;
    if (event.pointerType === 'mouse') event.preventDefault();
    pointerX = event.clientX; pointerY = event.clientY;
    dragTime = animation.currentTime || 0;
    dragging = true;
    container.classList.add('is-dragging');
    container.setPointerCapture(event.pointerId);
    sync();
  });
  container.addEventListener('pointermove', event => {
    if (!dragging || !animation) return;
    const delta = pointerX - event.clientX;
    if (Math.abs(delta) <= 6 || Math.abs(delta) <= Math.abs(pointerY - event.clientY)) return;
    animation.currentTime = ((dragTime + delta / 20 * 1000) % duration + duration) % duration;
  });
  function finishDrag() {
    dragging = false;
    container.classList.remove('is-dragging');
    sync();
  }
  container.addEventListener('pointerup', finishDrag);
  container.addEventListener('pointercancel', finishDrag);
  container.addEventListener('lostpointercapture', finishDrag);
  document.addEventListener('visibilitychange', sync);
  motion.addEventListener('change', rebuild);
  new IntersectionObserver(entries => { inView = entries[0].isIntersecting; sync(); }).observe(container);
  let lastWidth = 0;
  new ResizeObserver(entries => {
    const width = entries[0].contentRect.width;
    if (Math.abs(width - lastWidth) <= 1) return;
    lastWidth = width;
    cancelAnimationFrame(frame); frame = requestAnimationFrame(rebuild);
  }).observe(container);
  rebuild();
  if (document.fonts) document.fonts.ready.then(rebuild);
});

const optionsSliderv2 = {
    centeredSlides: false,	
    slidesPerView: 1.4,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween : 10,
        pagination: {
          el: ".swiper-pagination",
        },
        slideToClickedSlide: true,
    allowTouchMove: true,
      },
      992: {
        slidesPerView: 1.2,
        spaceBetween: 0,
         slideToClickedSlide: false,
    allowTouchMove: false,
      }
    },
  on: {
        init: function () {
            updateNavButtons(this); 
        },
        slideChange: function () {
            updateNavButtons(this);
        }
    }
};

function updateNavButtons(swiper) {
    let nextButton = document.querySelector('.swiper-button-next');
    let prevButton = document.querySelector('.swiper-button-prev');
    let totalSlides = swiper.slides.length;
    let slidesPerView = swiper.params.slidesPerView;
    
    let isEnd = swiper.isEnd;
    if (isEnd) {
        nextButton.classList.add("blurred");
    } else {
        nextButton.classList.remove("blurred");
    }
}

var productGalleryV2 = new Swiper(".product-slider-v2", optionsSliderv2);
setTimeout(function(){
  activateSlider();
},100);

function activateSlider(){
  var sliders = document.getElementsByClassName("product-area__media");
  Array.from(sliders).forEach(slider => {
    slider.style.visibility = 'visible';
  })
}

/** Quick View Product Slider **/
let modalOpenHandled = false;

const observer = new MutationObserver((mutations) => {
  if (!modalOpenHandled && document.body.classList.contains('modal-active')) {
    setTimeout(function(){
      new Swiper(".product-slider-v2", optionsSliderv2);
      activateSlider()
    },100)
  }
});

observer.observe(document.body, {
  attributes: true,
  attributeFilter: ['class']
});


const observer2 = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    // Check if nodes were removed
    if (mutation.removedNodes.length) {
      // Look for the quantity input
      const quantityWrapper = document.querySelector('.quantity-wrapper');
      if (!quantityWrapper) {
        // If quantity wrapper is gone, find and hide the label
        const quantityLabel = document.querySelector('.quantity-selector');
        if (quantityLabel) {
          quantityLabel.style.display = 'none';
        }
        
        // Also hide the entire wrapper if it exists
        const wrapperDiv = document.querySelector('.quantity-selector-wrapper');
        if (wrapperDiv) {
          wrapperDiv.style.display = 'none';
        }
      }
    }
  });
});

// Start observing the document with the configured parameters
observer2.observe(document.body, {
  childList: true,
  subtree: true
});
  
(function () {
  $(document).on("shopify:section:load", function (event) {

  });
})();

// Keep the original Instafeed grid and popup handlers; repeat a visual copy beside it.
(function initInstagramMarquee() {
  if (!document.body.classList.contains('template-index')) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const style = document.createElement('style');
  style.textContent = `
    #insta-feed .em-instagram-marquee { display:flex !important; overflow:hidden; gap:var(--em-feed-gap); }
    #insta-feed .em-instagram-marquee > .instafeed-new-layout-wrapper,
    #insta-feed .em-instagram-copy { flex:0 0 100%; min-width:0; will-change:transform; backface-visibility:hidden; }
  `;
  document.head.appendChild(style);
  const installed = new WeakSet();
  function install() {
    const root = document.querySelector('#insta-feed');
    if (!root) return;
    root.querySelectorAll('.instafeed-new-layout-container').forEach(container => {
      if (installed.has(container)) return;
      const original = container.querySelector('.instafeed-new-layout-wrapper');
      if (!original || original.children.length < 2) return;
      installed.add(container);
      let copy, animations = [], frame, distance = 0, layoutKey = '', previousItems = [];
      let offset = 0;
      let inView = false;
      function sync() {
        const paused = motion.matches || !inView || document.hidden ||
          (hover.matches && container.matches(':hover')) || container.contains(document.activeElement);
        animations.forEach(animation => paused ? animation.pause() : animation.play());
        // The original grid and repeat must share the same clock at the seam.
        if (!paused && animations.length === 2) {
          const pair = animations.slice();
          Promise.all(pair.map(animation => animation.ready)).then(() => {
            if (pair[0] === animations[0] && pair.every(animation => animation.playState === 'running')) {
              pair[1].startTime = pair[0].startTime;
            }
          }).catch(() => {}); // A responsive rebuild may cancel a pending animation.
        }
      }
      function rebuild() {
        const items = Array.from(original.children);
        const computed = getComputedStyle(original);
        const gap = parseFloat(computed.columnGap) || 10;
        const width = original.getBoundingClientRect().width;
        if (!width || items.length < 2) return;
        const key = [width.toFixed(2), gap, computed.gridTemplateColumns,
          ...items.map(item => Array.from(item.querySelectorAll('img')).map(image => image.getAttribute('src')).join('|'))].join(';');
        // Instafeed changes loading/hover styles frequently; those are not a new layout.
        if (!motion.matches && copy && key === layoutKey &&
            items.length === previousItems.length && items.every((item, index) => item === previousItems[index])) return;
        if (animations.length && distance) offset = ((Number(animations[0].currentTime) || 0) / 1000 * 20) % distance;
        animations.forEach(animation => animation.cancel());
        animations = [];
        if (copy) { copy.remove(); copy = null; }
        if (motion.matches) {
          container.classList.remove('em-instagram-marquee');
          layoutKey = '';
          return;
        }
        layoutKey = key;
        previousItems = items;
        copy = original.cloneNode(true);
        copy.className = 'em-instagram-copy';
        copy.setAttribute('aria-hidden', 'true');
        copy.style.display = 'grid';
        copy.style.gridTemplateColumns = computed.gridTemplateColumns;
        copy.style.gap = computed.gap;
        copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        copy.querySelectorAll('[tabindex],a,button,input,video').forEach(element => element.setAttribute('tabindex', '-1'));
        // Delegate duplicate clicks to the real app item so its modal stays authoritative.
        Array.from(copy.children).forEach((item, index) => {
          item.addEventListener('click', event => {
            event.preventDefault();
            event.stopImmediatePropagation();
            items[index].querySelector('[data-instafeed-role-button]')?.click();
          }, true);
        });
        container.style.setProperty('--em-feed-gap', gap + 'px');
        container.classList.add('em-instagram-marquee');
        container.appendChild(copy);
        distance = width + gap;
        [original, copy].forEach(element => {
          animations.push(element.animate(
            [{transform:'translate3d(0,0,0)'}, {transform:'translate3d(-' + distance + 'px,0,0)'}],
            {duration:distance / 20 * 1000, iterations:Infinity, easing:'linear'}
          ));
        });
        animations.forEach(animation => { animation.currentTime = (offset % distance) / 20 * 1000; });
        sync();
      }
      function schedule() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(rebuild);
      }
      container.addEventListener('mouseenter', sync);
      container.addEventListener('mouseleave', sync);
      container.addEventListener('focusin', sync);
      container.addEventListener('focusout', () => requestAnimationFrame(sync));
      document.addEventListener('visibilitychange', sync);
      motion.addEventListener('change', schedule);
      hover.addEventListener('change', sync);
      new IntersectionObserver(entries => { inView = entries[0].isIntersecting; sync(); }).observe(container);
      let lastWidth = 0;
      new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (Math.abs(width - lastWidth) > 1) { lastWidth = width; schedule(); }
      }).observe(container);
      new MutationObserver(records => {
        if (records.some(record => record.type === 'childList' ||
            record.target === original || record.target.parentElement === original ||
            (record.target.tagName === 'IMG' && record.attributeName === 'src'))) schedule();
      }).observe(original, {childList:true, subtree:true, attributes:true, attributeFilter:['style','src']});
      rebuild();
    });
  }
  new MutationObserver(install).observe(document.body, {childList:true, subtree:true});
  install();
})();

// Swiper can retain enabled navigation after a resize even when every card fits.
document.querySelectorAll('.product-slider .swiper-container').forEach(function (row) {
  const wrapper = row.querySelector('.swiper-wrapper');
  if (!wrapper) return;
  let frame, previousWidth;
  function checkOverflow() {
    if (row.swiper && previousWidth !== row.clientWidth) {
      previousWidth = row.clientWidth;
      row.swiper.update();
      if (row.swiper.navigation) row.swiper.navigation.update();
    }
    const slides = Array.from(wrapper.children).filter(element => element.classList.contains('swiper-slide'));
    const first = slides[0], last = slides[slides.length - 1];
    const contentWidth = first && last ? last.getBoundingClientRect().right - first.getBoundingClientRect().left : 0;
    const value = String(contentWidth > row.clientWidth + 1);
    if (row.dataset.rowOverflow !== value) row.dataset.rowOverflow = value;
  }
  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => { frame = requestAnimationFrame(checkOverflow); });
  }
  new ResizeObserver(schedule).observe(row);
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || record.target === wrapper ||
        record.target.parentElement === wrapper)) schedule();
  }).observe(wrapper, {childList:true, subtree:true, attributes:true, attributeFilter:['style']});
  schedule();
});

// Size only existing heading underlines to their final rendered text line.
(() => {
  const selector = '.feature-header, .shopify-policy__title h1';
  const headings = new Set();
  let frame;
  function measure(heading) {
    if (!heading.isConnected) { headings.delete(heading); resize.unobserve(heading); return; }
    const rule = getComputedStyle(heading, '::after');
    if (rule.content === 'none' || rule.content === 'normal' || rule.display === 'none' || parseFloat(rule.borderTopWidth) === 0) return;
    // Clear the previous width before measuring: an old desktop rule must not
    // become a flex item's minimum content width when the viewport narrows.
    heading.style.setProperty('--em-heading-rule-width', '0px');
    heading.setAttribute('data-em-heading-underline', '');
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    const rects = [];
    let node;
    while ((node = walker.nextNode())) {
      if (!node.textContent.trim()) continue;
      const range = document.createRange();
      const text = node.textContent;
      range.setStart(node, text.search(/\S/));
      range.setEnd(node, text.search(/\s*$/));
      for (const rect of range.getClientRects()) if (rect.width > .5 && rect.height > 0) rects.push(rect);
    }
    if (!rects.length) return;
    const bottom = Math.max(...rects.map(rect => rect.bottom));
    const lastLine = rects.filter(rect => Math.abs(rect.bottom - bottom) < 2);
    const left = Math.min(...lastLine.map(rect => rect.left));
    const right = Math.max(...lastLine.map(rect => rect.right));
    const box = heading.getBoundingClientRect();
    const style = getComputedStyle(heading);
    const inset = parseFloat(style.paddingLeft) + parseFloat(style.borderLeftWidth);
    const values = {
      '--em-heading-rule-width': (right - left) + 'px',
      '--em-heading-rule-left': Math.max(0, left - box.left - inset) + 'px'
    };
    for (const [name, value] of Object.entries(values)) {
      if (heading.style.getPropertyValue(name) !== value) heading.style.setProperty(name, value);
    }
    heading.setAttribute('data-em-heading-underline', '');
  }
  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => headings.forEach(measure));
  }
  const resize = new ResizeObserver(schedule);
  function discover() {
    document.querySelectorAll(selector).forEach(heading => {
      if (!headings.has(heading)) { headings.add(heading); resize.observe(heading); }
    });
    schedule();
  }
  discover();
  document.fonts.ready.then(schedule);
  document.fonts.addEventListener('loadingdone', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  new MutationObserver(discover).observe(document.querySelector('main') || document.getElementById('page-content') || document.body, {
    childList: true, subtree: true, characterData: true
  });
  document.addEventListener('shopify:section:load', discover);
})();

// Style the existing Tidio launcher locally; keep its native chat events and conversation UI.
(function initEasyMondaysChatBubble() {
  const styleId = 'em-corner-chat-style';
  const styledRoots = new WeakSet();
  const css = `
    #button.chat-closed .sidebar-content { display:none !important; }
    #button.chat-closed {
      position:fixed !important; inset:auto 20px max(20px, env(safe-area-inset-bottom)) auto !important;
      width:52px !important; height:52px !important; margin:0 !important;
      transform:none !important; pointer-events:none !important;
    }
    #button.chat-closed #button-body {
      position:relative !important; inset:auto !important; display:flex !important;
      width:52px !important; height:52px !important; border-radius:50% !important;
      background:#f95a30 !important; color:#fff !important; pointer-events:auto !important;
    }
    #button.chat-closed #button-body i.material-icons.type1,
    #button.chat-closed #button-body svg { width:24px !important; height:24px !important; color:#fff !important; }
    #button.chat-closed #button-body:focus-visible { outline:2px solid #21314d !important; outline-offset:4px !important; }
    @media(max-width:767px) {
      #button.chat-closed { right:16px !important; bottom:calc(max(16px, env(safe-area-inset-bottom)) + var(--em-sticky-purchase-offset, 0px)) !important; transition:bottom 180ms ease !important; }
      #tidio-chat-root.grid-layout:not(.mobile) { max-width:calc(100% - 32px) !important; margin-inline:16px !important; }
      #tidio-chat-root.grid-layout:not(.mobile) .chat { width:100% !important; max-width:100% !important; }
    }
    @media(prefers-reduced-motion:reduce) { #button.chat-closed { transition:none !important; } }
  `;
  function install() {
    const root = document.querySelector('#tidio-chat')?.shadowRoot;
    if (!root) return false;
    function ensureStyle() {
      if (root.getElementById(styleId)) return;
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.appendChild(style);
    }
    ensureStyle();
    if (!styledRoots.has(root)) {
      styledRoots.add(root);
      new MutationObserver(ensureStyle).observe(root, {childList:true});
    }
    return true;
  }
  if (install()) return;
  // Tidio attaches its shadow root asynchronously, outside ordinary DOM mutation events.
  let attempts = 0;
  const timer = setInterval(() => {
    if (install() || ++attempts >= 120) clearInterval(timer);
  }, 500);
})();

// Mobile collection toolbar: keep native Shopify facets inside a dismissible side drawer.
(function () {
  const toolbar = document.querySelector('[data-em-collection-toolbar]');
  if (!toolbar) return;
  const section = toolbar.closest('.theme-filter-container');
  if (!section) return;
  section.classList.add('em-mobile-collection');
  section.prepend(toolbar);
  const mobile = window.matchMedia('(max-width:767px)');
  const nav = document.getElementById('site-control');
  const backdrop = document.createElement('button');
  backdrop.type = 'button'; backdrop.className = 'em-filter-backdrop';
  backdrop.setAttribute('aria-label', 'Close filters'); backdrop.tabIndex = -1;

  const opener = toolbar.querySelector('[data-em-filter-open]');
  const drawerId = opener.getAttribute('aria-controls');
  let open = false, frame;
  function drawer() { return section.querySelector('.cc-product-filter'); }
  function sync() {
    const panel = drawer();
    if (!panel) return;
    if (backdrop.parentElement !== panel.parentElement) panel.parentElement.appendChild(backdrop);
    const active = mobile.matches && open;
    panel.id = drawerId;
    panel.classList.toggle('-in', active);
    opener.setAttribute('aria-expanded', String(active));
    document.body.classList.toggle('em-filter-open', active);
    if (mobile.matches) {
      panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'Collection filters');
      panel.setAttribute('aria-modal', 'true'); panel.inert = !active;
    } else {
      panel.removeAttribute('role'); panel.removeAttribute('aria-label'); panel.removeAttribute('aria-modal'); panel.inert = false;
    }
  }
  function setOpen(value) {
    open = value; sync();
    if (open) setTimeout(() => { if (open) drawer()?.querySelector('[data-em-filter-close]')?.focus({preventScroll:true}); }, 260);
    else opener.focus({preventScroll:true});
  }
  function headerOffset() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const hidden = !nav || document.body.classList.contains('em-collection-nav-away') || nav.classList.contains('nav-hidden') || nav.classList.contains('nav-fade-out');
      const bottom = hidden ? 0 : Math.max(0, nav.getBoundingClientRect().bottom);
      toolbar.style.setProperty('--em-collection-nav-bottom', bottom + 'px');
    });
  }
  document.addEventListener('click', event => {
    if (!mobile.matches) return;
    if (event.target.closest('[data-em-filter-open]') === opener) { event.preventDefault(); setOpen(true); }
    else if (section.contains(event.target) && event.target.closest('[data-em-filter-close]')) { event.preventDefault(); setOpen(false); }
  });
  backdrop.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', event => {
    if (!mobile.matches || !open) return;
    if (event.key === 'Escape') { event.preventDefault(); setOpen(false); return; }
    if (event.key !== 'Tab') return;
    const controls = [...drawer().querySelectorAll('button,a[href],input,select,summary,[tabindex]')].filter(e => !e.disabled && e.tabIndex >= 0 && e.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  new MutationObserver(sync).observe(section.querySelector('[data-ajax-container].cc-product-filter-container'), {childList:true});
  if (nav) {
    new MutationObserver(headerOffset).observe(nav, {attributes:true, attributeFilter:['class','style']});
    new ResizeObserver(headerOffset).observe(nav);
  }
  let previousScroll = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (mobile.matches && !open && Math.abs(y - previousScroll) > 4) {
      document.body.classList.toggle('em-collection-nav-away', y > 100 && y > previousScroll);
      previousScroll = y;
    }
    headerOffset();
  }, {passive:true});
  window.addEventListener('resize', headerOffset);
  mobile.addEventListener('change', () => { open = false; document.body.classList.remove('em-collection-nav-away'); previousScroll = window.scrollY; sync(); headerOffset(); });
  sync(); headerOffset();
})();
